import React from 'react';
import { useParams } from 'react-router-dom';
import { TDR } from 'tdr-common';
import { EcommerceMandatorySection } from './steps/EcommerceMandatorySection';
import { EcommerceOptionalSection } from './steps/EcommerceOptionalSection';
import { Policies } from './steps/Policies';
import { Details } from './steps/Details';
import { Payment } from './steps/Payment';
import { StripeWrapper } from './StripeWrapper';
import { useCheckoutContext } from '../../context/new/CheckoutContext';

export const DynamicCheckoutRoute = () => {
	const { step } = useParams<{ step: string }>();
	const { navConfig } = useCheckoutContext();


	// Get current step from the navConfig provided by CheckoutContext
	const currentStep = navConfig[step];
	if (!currentStep) {
		// Fallback: Try to render standard steps if they match
		const standardSteps = ['policies', 'details', 'payment'];
		if (standardSteps.includes(step)) {

			switch (step) {
				case 'policies':
					return <Policies />;
				case 'details':
					return <Details />;
				case 'payment':
					return (
						<StripeWrapper>
							<Payment />
						</StripeWrapper>
					);
			}
		}

		return null;
	}

	if (currentStep.isEcommerce) {
		if (!currentStep.sectionData) {
			return <div style={{ padding: '20px', color: 'red' }}>
				ERROR: No section data for &quot;{currentStep.title}&quot;
			</div>;
		}

		// Determine which component to render based on validation type
		const validationType = currentStep.validation?.type || TDR.Ecommerce.ValidationType.Open;

		if (validationType === TDR.Ecommerce.ValidationType.SingleMandatory) {
			return <EcommerceMandatorySection key={step} sectionData={currentStep.sectionData} />;
		}
		else {
			// For 'open' and 'mixed-mandatory', use the optional section with different restrictions
			return <EcommerceOptionalSection key={step} sectionData={currentStep.sectionData} />;
		}
	}

	// Handle standard checkout steps

	switch (step) {
		case 'ecommerce-1':
		case 'ecommerce-2':
		case 'ecommerce-3':
			return <Policies />;
		case 'policies':
			return <Policies />;
		case 'details':
			return <Details />;
		case 'payment':
			return (
				<StripeWrapper>
					<Payment />
				</StripeWrapper>
			);
		default:
			return <Policies />;
	}
};